var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-added"},[_c('p',{class:_vm.dataClass},[_vm._v(" "+_vm._s(_vm.text)+" "),(_vm.showDelete)?_c('v-icon',{staticClass:"toggleIcon mr-2 cursorPointer",on:{"click":_vm.clickEvent}},[_vm._v("close")]):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }